import {DAEAttributes} from './DAEAttributes';
import {E015Attributes} from './E015Attributes';
import {ProductType} from "./ProductType";
import {ProductItemChargerRelationDTO} from "./ProductItemChargerRelationDTO";
import {Charger} from "../../Ope/Charger/Charger";

export class CustomerProductItemFull {
  public id!: string;
  public name!: string;
  public label!: string;
  public registryStatus!: string;
  public customerId!: string;
  public latitude?: number;
  public longitude?: number;
  public location!: string;
  public serialNumber!: string;
  public productType!: ProductType;
  public hasDae = false;
  public isE015 = false;
  public hasOsmUrl = false;
  public useChirpstack = false;
  public devEui?: string;
  public osmUrl?: string;
  public note?: string;
  public imageUrl?: string;
  public isMonitored!: boolean;

  public daeAttributes!: DAEAttributes;
  public e015Attributes!: E015Attributes;
  public chargers: ProductItemChargerRelationDTO[] = [];
  public allChargers?: Charger[];

  constructor() {
    this.daeAttributes = new DAEAttributes();
    this.e015Attributes = new E015Attributes();
    this.allChargers = new Array<Charger>();
    this.chargers = new Array<ProductItemChargerRelationDTO>();
  }

}
